if (typeof AgeVerification !== "function") {
    class AgeVerification extends HTMLElement {
        constructor() {
            super();
            this.consentCheckbox = this.querySelector('input[type="checkbox"]');
            this.cartDrawerButton = null;

            this.observeDOMChanges();
        }

        observeDOMChanges() {
            const observer = new MutationObserver((mutations) => {
                mutations.forEach((mutation) => {
                    if (mutation.type === 'childList') {
                        this.initialize();
                    }
                });
            });

            observer.observe(document.body, {
                childList: true,
                subtree: true
            });
        }

        initialize() {
            if (this.dataset.location === 'drawer') {
                this.cartDrawerButton = this.closest('sidebar-drawer')?.querySelector('#CheckOut');
            } else if (this.dataset.location === 'cart') {
                this.cartDrawerButton = this.closest('#AjaxCartSubtotal')?.querySelector('#CheckOut');
            }

            if (this.classList.contains('age-verification--required')) {
                this.consentCheckbox.addEventListener('change', this.updateAgeVerification.bind(this));
                this.updateAgeVerification();
            }
        }

        updateAgeVerification() {
            if (this.consentCheckbox.checked) {
                sessionStorage.setItem('age-verified', true);
            } else {
                sessionStorage.removeItem('age-verified');
            }
            this.updateCheckoutButton();
        }

        updateCheckoutButton() {
            if (sessionStorage.getItem('age-verified')) {
                this.cartDrawerButton?.removeAttribute('disabled');
            } else {
                this.cartDrawerButton?.setAttribute('disabled', 'disabled');
            }
        }
    }

    if (typeof customElements.get("age-verification") == "undefined") {
        customElements.define("age-verification", AgeVerification);
    }
}